export const ASSIGNMENT_UPDATE = 'ASSIGNMENT_UPDATE';